<template>

  <div ref="main" class="app">

    <app-header></app-header>

    <div class="grid-container">

      <!-- resume -->
      <router-view name="experience"></router-view>

      <!--named as intro on home or other default if no name, see routes.js -->
      <router-view name="intro"></router-view>

      <router-view></router-view>

      <!-- logo array on home using ARRAY data -->
      <router-view name="clientLogos">
        <router-link v-for="featured in $options.portfolioData"
                     :key="featured.client"
                     class="cell"
                     :to="{ name: 'portfolio-detail', params: { client: featured.client } }">
          <img :src="imagePath(featured.logo)">
        </router-link>
      </router-view>

      <!-- <router-view v-bind:myName="name" name="portfolio"> -->
      <!-- in the child add a prop and pass it through for interpolation -->
      <router-view name="portfolio"
                   :clientProp="$options.clientData"
                   :portfolioProp="$options.portfolioData">
      </router-view>

    </div>
    <footer>
      <span class="footer-1200"></span>
      <span class="footer-1024"></span>
      <span class="footer-768"></span>
      <span class="footer-640"></span>
    </footer>
  </div>


</template>

<script>
  import TweenMax from 'gsap';
  import Header from './components/Header.vue';
  // import axios from 'axios';s

  import img from './images/favicon.png';
  console.log(img);

  // IMPORTING A JS OBJECT (this has several objects that can be imported by name)
  import { clientList, portfolioData, clientData } from './workData';

  export default {
    name: 'app',
    // you use vm.$options in the render to get these objects.
    // if you did an import you need to expose them here too if you intend to display
    clientList,
    portfolioData,
    clientData,

    data() {
      return {
        // you should only use reactive objects here in data()
        // but if it is here you don't need to use options
      }
    },
    computed: {
      // imagePath: function () {
      // return require('~assets/' + this.country.name + '.jpg')
      // return require('../assets/test-logo.png');
      // }
    },
    mounted() {
      document.onreadystatechange = () => {
        if (document.readyState === "complete") {
          // run code here
          console.log("READY COMPLETED ", document.readyState);
          TweenMax.to(this.$refs.main, 0.6, {autoAlpha: 1});
        }
      }
      // USE AXIOS if you get data external
    },
    methods: {
      imagePath(clientLogo) {
        /*
        * A WEBPACK THING: https://vuejs-templates.github.io/webpack/static.html
        * Note the above example will include every image under ./bgs/ in the final build.
        * This is because Webpack cannot guess which of them will be used at runtime,
        * so it includes them all.
        *
        * This could be useful, everything in assets is going to be available to use in the template.
        */
        // decided to have assets hold everything but use images as the 'in use' directory
        return require('./images/' + clientLogo);
      }
    },
    components: {
      appHeader: Header
    }
  }
</script>

<style lang="scss">
  @import '~foundation-sites/scss/foundation.scss';
  @import './css/settings';
  @import './css/colors';

  body {
    /*overflow: scroll;*/
  }

  /* same as body flex to fill height with flex-direction: column*/
  .app {
    display: flex;
    /*-ms-flex-align: center;*/
    flex-direction: column;
    height: 100vh;
    /*padding-top: 1rem;*/
    /*visibility: hidden;*/
    /*opacity: 0;*/
}

  .grid-container {
    flex: 1 0 auto;
    align-self: center;
    /*max-width: 64rem;*/
    /*margin: 0 auto;*/
  }

  footer {
    position: relative;
    height: 6px;
    width: 100%;
    overflow: hidden;
    background-color: $deepSilver;
    flex-shrink: 0;

    span {
      position: absolute;
      display: inline-block;
      height: 100%;
      left: 0;
      bottom: 0;
    }
    .footer-640 {
      width: 640px;
      background-color: $deepYellow;
    }
    .footer-768 {
      width: 768px;
      background-color: $deepGreen;
    }
    .footer-1024 {
      width: 1024px;
      background-color: $deepBlue;
    }
    .footer-1200 {
      width: 1200px;
      background-color: $deepThistle;
    }
  }



</style>



// WEBPACK FOOTER //
// src/App.vue